import { version } from '../../package.json';

export const load = () => {
    const _config = {
        name: 'Templating UI',
        description: 'Templating application frontend',
        version: version,
        keeper: {
            safe: false,
        },
        logLevel: ['console'], // 'console', 'log'
        roles: {
            any: [],
            all: ['NONE', 'READER', 'EXTSYS', 'WRITER', 'VALIDATOR', 'ADMIN'],
            logged: ['READER', 'EXTSYS', 'WRITER', 'VALIDATOR', 'ADMIN'],
            readers: ['READER', 'WRITER', 'VALIDATOR', 'ADMIN'],
            writers: ['WRITER', 'VALIDATOR', 'ADMIN'],
            validators: ['VALIDATOR', 'ADMIN'],
            admins: ['ADMIN'],
        },
        templates: {
            types: ['PDF', 'EMAIL', 'SMS', 'INBOX'],
            allowTypes: ['PDF', 'EMAIL', 'SMS'],
            states: ['DRAFT', 'APPROVED'],
        },
        defualtLang: 'cs',
        supportedLangs: ['cs', 'en'],
        snippets: {
            types: {
                body: {
                    templates: ['PDF', 'EMAIL'],
                },
                header: {
                    templates: ['PDF', 'EMAIL'],
                },
                footer: {
                    templates: ['PDF', 'EMAIL'],
                },
            },
        },
        rank: {
            NONE: 0,
            READER: 100,
            EXTSYS: 200,
            WRITER: 300,
            VALIDATOR: 400,
            ADMIN: 1000,
        },
        image: {
            maxWidth: 1024,
            maxHeight: 1024,
        },
        cleanTablePolicy: false,
        fonts: [
            {
                name: 'Arial Unicode MS',
                family: 'Arial Unicode MS',
            },
            {
                name: 'Arial (Inter)',
                family: 'Inter',
            },
            {
                name: 'Open Sans',
                family: 'Open Sans',
            },
            {
                name: 'Roboto',
                family: 'Roboto',
            },
            {
                name: 'Roboto Flex',
                family: 'Roboto Flex',
            },
            {
                name: 'Roboto Mono',
                family: 'Roboto Mono',
            },
        ],
        env: {
            name: 'localdev-initial',
            hosts: ['localhost'],
            apiUrl: 'https://localhost:8443',
            fileStorageApiUrl: 'https://file-storage-crdbe.softino.cloud',
            fileStorageBaseUrl: 'https://public-file-storage.softino.cloud',
            fileStorageEnabled: false,
            docker: false,
            requiredComplexity: 7,
        },
    };

    if (Intl) {
        const dt = new Date();
        _config.env.tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        _config.env.tzOffset = dt.getTimezoneOffset();
    }

    if (typeof window.ENV === 'object') {
        _config.env = startEnv(_config.env, window.ENV);
        _config.env.apiUrl = sanitizeUrl(_config.env.apiUrl);
        _config.env.fileStorageApiUrl = sanitizeUrl(window.ENV.fileStorageApiUrl);
        _config.env.fileStorageBaseUrl = sanitizeUrl(window.ENV.fileStorageBaseUrl);
        _config.env.defualtLang = window.ENV.defualtLang || _config.defualtLang;
        _config.env.supportedLangs = window.ENV.supportedLangs || _config.supportedLangs;
    }
    return _config;
};

export const sanitizeUrl = (str) => {
    return str.endsWith('/') ? str.slice(0, -1) : str;
};

export const startEnv = (origin, _env) => {
    const hostname = getHostname();
    if (Array.isArray(_env.hosts) && _env.hosts.length > 0 && _env.hosts.includes(hostname)) {
        Object.entries(_env).forEach((item) => {
            origin[item[0]] = item[1];
        });
    }
    return origin;
};

export const getHostname = () => {
    return window.location.hostname;
};

export const useConfig = () => {
    return {
        load: load,
        sanitizeUrl: sanitizeUrl,
        startEnv: startEnv,
        getHostname: getHostname,
    };
};

export default useConfig;
